<!-- 免责声明 -->
<template>
  <div class="disclaimers">
    <el-checkbox 
      v-model="val" 
      class="disclaimers__checkbox"
      @change="val => $emit('input', val)"
    >
      我已知悉
      <BaseTipPopover width="420px" placement="top" >
        <span slot="reference" class="disclaimers__checkbox__text" @click.prevent>《免责声明》</span>
        <div>
          免责声明：请认真填写订单参数，PCB生产以系统下单参数为准，其它内容如：（订单备注，PCB文件名，压缩包内附件等）参数一律视为无效参数。且同意
          <BaseLink href="https://www.hqpcb.com/help/p_1824.html" target="_blank">
            《PCB下单重要提醒 必看！!》
          </BaseLink>
          <BaseLink href="https://www.hqpcb.com/help/p_1692.html" target="_blank">
            《PCB下单前工程师 必看!》
          </BaseLink>
          <BaseLink href="https://www.hqpcb.com/ability.html" target="_blank">
            《制造能力》
          </BaseLink>
        </div>
      </BaseTipPopover>
    </el-checkbox>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: this.value
    }
  },
  watch: {
    value(newVal) {
      this.val = newVal
    }
  }
}
</script>

<style lang="scss" scoped>
.disclaimers {
  display: flex;
  justify-content: flex-end;
  margin: 8px 15px 8px 0;
  .disclaimers__checkbox ::v-deep {
    line-height: 16px;
    .el-checkbox__label {
      padding-left: 5px;
      line-height: 16px;
      color: #555555;
      font-size: 12px;
    }
    .el-checkbox__inner:hover,
    .el-checkbox__input.is-focus .el-checkbox__inner {
      border-color: $--form-color-base;
    }
    .el-checkbox__input.is-checked+.el-checkbox__label {
      color: $--form-color-base;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner, 
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      border-color: $--form-color-base;
      background-color: $--form-color-base;
    }
    .disclaimers__checkbox__text {
      margin-left: -3px;
      color: $--link-color;
      cursor: default;
    }
  }
}
</style>